import React from 'react'
import userPhoto from '../../assets/aashto/user.png'
import qrCode from '../../assets/icpa/qr.png'

const Icpa2026Page = () => {
  return (
    <div dangerouslySetInnerHTML={{ __html: `<!DOCTYPE html>
      <html lang="en">
      <head>
      <meta charset="UTF-8">
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <title>LusidPay | ICPA</title>
      <style>
        /* Base Reset & Typography */
        * { box-sizing: border-box; margin: 0; padding: 0; }
        body {
          // font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
          background-color: #f8f9fa;
          color: #1a202c;
          line-height: 1.5;
          -webkit-font-smoothing: antialiased;
        }

        /* Main Container */
        .container {
          max-width: 480px;
          margin: 0 auto;
          background-color: #ffffff;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
          min-height: 100vh;
          display: flex;
          flex-direction: column;
        }

        @media (min-width: 768px) {
          .container {
            max-width: 640px;
            border-radius: 16px;
            margin: 24px auto;
            overflow: hidden;
          }
          .contact-info h1 { font-size: 22px; }
          .contact-info h2 { font-size: 15px; }
          .contact-info p  { font-size: 13px; }
          .profile-photo { width: 100px; height: 100px; }
          .qr-code { width: 95px; height: 95px; }
          .pitch-section h3 { font-size: 24px; }
          .pitch-section p  { font-size: 15px; }
          .btn { font-size: 16px; padding: 14px; }
          .summary-block h4 { font-size: 17px; }
          .summary-block p,
          .summary-block li { font-size: 15px; }
        }

        @media (min-width: 1024px) {
          .container {
            max-width: 720px;
            margin: 32px auto;
            border-radius: 16px;
          }
          .profile-photo { width: 120px; height: 120px; }
          .qr-code { width: 110px; height: 110px; }
          .screenshot-zone { padding: 32px 32px 28px 32px; }
          .executive-summary { padding: 32px; }
        }

        /* --- 1. THE SCREENSHOT ZONE (Above the Fold) --- */
        .screenshot-zone {
          padding: 24px 20px 20px 20px;
          border-bottom: 4px solid #004080; /* Enterprise Navy Blue Accent */
          background-color: #ffffff;
        }

        /* Header: Photo, Contact, and QR Code */
        .profile-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 12px;
          margin-bottom: 20px;
        }
        .profile-photo {
          width: 80px;
          height: 80px;
          border-radius: 50%;
          object-fit: cover;
          object-position: center 30%;
          border: 2px solid #e2e8f0;
          flex-shrink: 0;
        }
        .contact-info {
          flex-grow: 1;
        }
        .contact-info h1 {
          font-size: 18px;
          font-weight: 800;
          color: #004080;
          margin-bottom: 0px;
          line-height: 1.2;
        }
        .contact-info h2 {
          font-size: 13px;
          font-weight: 600;
          color: #4a5568;
          margin-bottom: 4px;
        }
        .contact-info p {
          font-size: 12px;
          color: #4a5568;
          line-height: 1.4;
        }
        .contact-info a {
          color: #004080;
          text-decoration: none;
          font-weight: 600;
        }
        .qr-code {
          width: 80px;
          height: 80px;
          flex-shrink: 0;
          border: 1px solid #e2e8f0;
          border-radius: 4px;
        }

        /* Pitch Headlines */
        .pitch-section {
          text-align: left;
          margin-bottom: 20px;
        }
        .pitch-section h3 {
          font-size: 20px;
          font-weight: 800;
          line-height: 1.25;
          color: #1a202c;
          margin-bottom: 8px;
        }
        .pitch-section p {
          font-size: 14px;
          color: #4a5568;
          font-weight: 500;
        }

        /* Action Buttons */
        .action-buttons {
          display: flex;
          flex-direction: column;
          gap: 10px;
        }
        .btn {
          display: block;
          width: 100%;
          padding: 12px;
          text-align: center;
          border-radius: 8px;
          font-size: 15px;
          font-weight: 700;
          text-decoration: none;
          transition: all 0.2s ease;
        }
        .btn-primary {
          background-color: #004080;
          color: #ffffff;
          border: 2px solid #004080;
        }
        .btn-secondary {
          background-color: #ffffff;
          color: #004080;
          border: 2px solid #004080;
        }

        /* --- 2. THE EXECUTIVE SUMMARY (Below the Fold) --- */
        .executive-summary {
          padding: 24px 20px;
          background-color: #f8f9fa;
          flex: 1;
        }
        .summary-block {
          margin-bottom: 20px;
        }
        .summary-block h4 {
          font-size: 16px;
          font-weight: 800;
          color: #004080;
          margin-bottom: 25px;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }
        .summary-block p {
          font-size: 14px;
          color: #2d3748;
          margin-bottom: 25px;
        }
        .summary-block ul {
          padding-left: 20px;
        }
        .summary-block li {
          font-size: 14px;
          color: #2d3748;
          margin-bottom: 8px;
        }
        .summary-block li strong {
          color: #1a202c;
        }
      </style>
      </head>
      <body>

      <div class="container">
        
        <div class="screenshot-zone">
          
          <div class="profile-header">
            <img src="${userPhoto}" alt="Rajeev Malhotra" class="profile-photo">
            
            <div class="contact-info">
              <h1>Rajeev Malhotra</h1>
              <h2>Founder & CEO, LusidPay Inc.</h2>
              <p>📱 Direct: (202) 410-0500</p>
              <p>✉️ <a href="mailto:rajeev@lusidpay.com">rajeev@lusidpay.com</a></p>
            </div>

            <img src="${qrCode}" alt="ICPA2026 Link" class="qr-code">
          </div>

          <div class="action-buttons">
            <a href="https://scheduler.zoom.us/rajeev-malhotra/30-min" class="btn btn-primary" target="_blank">
              📅 Book 30-Min Executive Briefing
            </a>
            <a href="https://blinq.me/LFx0i3ZQkXbhGqvvTnGz" class="btn btn-secondary" target="_blank">
              📥 Save Contact Info (Blinq)
            </a>
          </div>

        </div>

        <div class="executive-summary">
          
          <div class="summary-block">
            <h4>Enterprise CFR 19 Audit Defense</h4>
            <p style="margin-bottom: 0px;"><strong>1. The Deterministic Ledger</strong></p>
            <p>We replace 5% manual sampling with mathematically perfect 100% pre-entry audits. Our AI executes a 3-way match across unstructured Commercial Invoices, Packing Lists, and BOLs before your Customs Broker hits transmit.</p>

            <p style="margin-bottom: 0px;"><strong>2. Evidentiary Anchors</strong></p>
            <p>Outputting a FOIA-Exempt (Exemption 4) Personal Narrative Package where every calculated value is cryptographically anchored to a specific bounding box on your source documents.</p>

            <p style="margin-bottom: 0px;"><strong>3. The Restricted Wallet</strong></p>
            <p>Eliminate broker bankruptcy and commingling risk. Route duty payments directly to CBP via the ACE portal while simultaneously automating your broker's AP/AR fees.</p>

          </div>

        </div>

      </div>

      </body>
      </html>` 
    }}></div>
  )
}

export default Icpa2026Page;